<template>
  <div>
    <h4><i class="fas fa-cart-arrow-down"></i> Blue Badges</h4>
    <b-table :items="data" :fields="['first_name', 'dob', 'address_line_1']">
      <template #head(first_name)>Owner</template>
      <template #cell(first_name)="data">
        <div>{{ data.value }} {{ data.item.last_name }}</div>
        <code>{{ data.item.nation_insurance_no }}</code>
      </template>
      <template #cell(dob)="data">{{ data.value | moment('Do MMM YYYY') }}</template>
      <template #cell(address_line_1)="data">{{ data.value }}<br/>{{ data.item.address_line_2 }}<br/>{{ data.item.post_code }}</template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: ['data'],
};
</script>
